import { css } from "react-emotion";

export default {
  INTIAIL: css`
    transform: translateY(-100%) translateX(0) skewY(0) skewX(0);
    transition: all 750ms ease-in;
  `,
  INTRO_ENTER: css`
    transform: translateY(-50%) translateX(0) skewY(0) skewX(0);
  `,
  INTRO_LEAVE: css`transform: translateY(0%) translateX(0) skewY(0) skewX(0);`,
  WORK_ENTER: css`
    transform: translateY(0%) translateX(40%) skewY(0) skewX(10deg);
    transition: all 500ms ease-in;
  `,
  WORK_1: css`
    transform: translateY(0%) translateX(-40%) skewY(0) skewX(-10deg);
    transition: all 500ms ease-in;
  `,
  WORK_2: css`
    transform: translateY(0%) translateX(40%) skewY(0) skewX(10deg);
    transition: all 500ms ease-in;
  `,
  WORK_3: css`
    transform: translateY(0) translateX(0) skewY(0) skewX(0);
    transition: all 500ms ease-in;
  `,
  PROCESS_1: css`
    transform: translateY(0) translateX(0) skewY(0) skewX(0) scale(0.2);
    transition: all 500ms ease-in;
  `,
  PROCESS_2: css`
    transform: translateY(0%) translateX(0%) skewY(0) skewX(-45deg) scale(1);
    transition: all 500ms ease-in;
  `,
  PROCESS_3: css`
    transform: translateY(0%) translateX(0%) skewY(0) skewX(45deg) scale(1);
    transition: all 500ms ease-in;
  `,
  PROCESS_4: css`
    transform: translateY(0%) translateX(0%) skewY(0) skewX(-45deg) scale(1);
    transition: all 500ms ease-in;
  `,
  PROCESS_5: css`
    transform: translateY(0%) translateX(0%) skewY(0) skewX(45deg) scale(1);
    transition: all 500ms ease-in;
  `,
  TEAM_1: css`
    transform: translateY(-50%) translateX(-50%) skewY(0) skewX(0) scale(1);
    transition: all 500ms ease-in;
  `,
  TEAM_2: css`
    transform: translateY(-50%) translateX(50%) skewY(0) skewX(0) scale(1);
    transition: all 500ms ease-in;
  `,
  TEAM_3: css`
    transform: translateY(50%) translateX(-50%) skewY(0) skewX(0) scale(1);
    transition: all 500ms ease-in;
  `,
  TEAM_4: css`
    transform: translateY(50%) translateX(50%) skewY(0) skewX(0) scale(1);
    transition: all 500ms ease-in;
  `,
  FOOTER: css`
    transform: translateY(0) translateX(0) skewY(0) skewX(0) scale(1);
    transition: all 500ms ease-in;
  `,
  WORK_0: css`
    transform: translateY(0) translateX(0) skewY(0) skewX(0) scale(1);
    transition: all 500ms ease-in;
  `,
  TEAM_1: css`
    transform: translateY(0) translateX(0) skewY(0) skewX(0) scale(1);
    transition: all 500ms ease-in;
  `,
  CLEAR: css`
    transform: translateY(-1000) translateX(0) skewY(0) skewX(0) scale(1);
    transition: all 500ms ease-in;
  `,
  DIAGONAL_LEFT: css`
    transform: translateY(0%) translateX(0%) skewY(0) skewX(-45deg) scale(1);
    transition: all 500ms ease-in;
  `,
  DIAGONAL_RIGHT: css`
    transform: translateY(0%) translateX(0%) skewY(0) skewX(45deg) scale(1);
    transition: all 500ms ease-in;
  `
};



// WEBPACK FOOTER //
// ./src/components/Background/styles.js